/* PITA auto-linking (Phase 93).
   Anywhere the word "PITA" appears in normal rendered rich/WYSIWYG content,
   link it to /issue-tracker. Rules:
   - never create nested anchors (skips text already inside <a> or <button>)
   - skips headings (h1-h3) so hero/section titles stay clean
   - production-safe: uses the relative route, never a hardcoded domain */
export const linkifyPita = (html) => {
  if (!html || !/\bPITA\b/.test(html)) return html;
  try {
    const doc = new DOMParser().parseFromString(`<div id="__root">${html}</div>`, 'text/html');
    const root = doc.getElementById('__root');
    const walker = doc.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((n) => {
      if (!/\bPITA\b/.test(n.nodeValue || '')) return;
      let el = n.parentElement;
      while (el && el !== root) {
        const tag = el.tagName;
        if (tag === 'A' || tag === 'BUTTON' || /^H[1-3]$/.test(tag)) return;
        el = el.parentElement;
      }
      const frag = doc.createDocumentFragment();
      (n.nodeValue || '').split(/\b(PITA)\b/).forEach((part) => {
        if (part === 'PITA') {
          const a = doc.createElement('a');
          a.setAttribute('href', '/issue-tracker');
          a.setAttribute('class', 'pita-link');
          a.setAttribute('data-testid', 'pita-auto-link');
          a.textContent = 'PITA';
          frag.appendChild(a);
        } else if (part) {
          frag.appendChild(doc.createTextNode(part));
        }
      });
      n.parentNode.replaceChild(frag, n);
    });
    return root.innerHTML;
  } catch {
    return html;
  }
};
